import lessvars from './modules/lessvars';

const theme = window.HIVE_ADMIN_THEME = {
  less: lessvars,
  monospaceFontStack: [
    'ui-monospace',
    'Menlo',
    'Monaco',
    '"Cascadia Mono"',
    '"Segoe UI Mono"',
    '"Roboto Mono"',
    '"Oxygen Mono"',
    '"Ubuntu Monospace"',
    '"Source Code Pro"',
    '"Fira Mono"',
    '"Droid Sans Mono"',
    '"Courier New"',
    'monospace',
  ].join(',\n'),
};

export default theme;
